/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
/* Keep the app's sage SVG heart; remove duplicate heart characters from its label. */
(function () {
  function cleanWishlistLabel() {
    var icon = document.getElementById('swym-atw-pdp-button-icon');
    if (icon && icon.getAttribute('viewBox') !== '0 0 24 24') icon.setAttribute('viewBox', '0 0 24 24');
    var label = document.getElementById('swym-atw-pdp-button-text');
    if (!label) return;
    var original = label.textContent;
    var cleaned = original.replace(/^[\s♡♥❤\uFE0F]+/, '');
    if (cleaned !== original) label.textContent = cleaned;
  }
  function start() {
    var productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;
    cleanWishlistLabel();
    new MutationObserver(cleanWishlistLabel).observe(productForm, {
      childList: true, subtree: true, characterData: true
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
